import * as React from "react";

const SvgComponent = ({ width = "10px", height = "10px", color = "#fff", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.9}>
      <path
        d="M9.152 8.311 6.924 6.07c1.08-1.494.96-3.602-.387-4.95a3.833 3.833 0 0 0-5.416 0 3.833 3.833 0 0 0 0 5.417c1.347 1.347 3.455 1.467 4.949.387l2.241 2.24c.24.24.614.24.854 0a.608.608 0 0 0-.013-.853ZM1.72 5.936a2.987 2.987 0 0 1 0-4.215 2.987 2.987 0 0 1 4.216 0 2.987 2.987 0 0 1 0 4.215 2.987 2.987 0 0 1-4.216 0Z"
        fill={color}
      />
      <path
        d="M5.349 3.388H4.28V2.321c0-.24-.2-.454-.453-.454-.24 0-.454.2-.454.454v1.067H2.307c-.24 0-.453.2-.453.454 0 .24.2.453.453.453h1.067v1.067c0 .24.2.454.454.454.24 0 .453-.2.453-.454V4.295H5.35c.24 0 .453-.2.453-.453a.467.467 0 0 0-.453-.454Z"
        fill={color}
      />
    </g>
  </svg>
);

export default SvgComponent;
